const STYLES = {
  done: "bg-[#2D6A4F]/10 text-[#2D6A4F] border-[#2D6A4F]/30",
  failed: "bg-red-50 text-red-700 border-red-200",
  queued: "bg-[#E2D9CC]/50 text-[#8C827A] border-[#E2D9CC]",
};
const LABELS = { done: "Ready", failed: "Failed", queued: "Queued", researching: "Researching", writing: "Writing", rendering: "Rendering", updating: "Updating" };

export const StatusBadge = ({ status, testId }) => (
  <span data-testid={testId} className={`inline-flex items-center gap-1.5 px-2.5 py-1 border text-[11px] font-mono-accent uppercase tracking-wider ${STYLES[status] || "bg-[#C59B27]/10 text-[#B45309] border-[#C59B27]/30"}`}>
    {!["done", "failed", "queued"].includes(status) && <span className="w-1.5 h-1.5 rounded-full bg-[#C59B27] pulse-node" />}
    {LABELS[status] || status}
  </span>
);
